module.exports = __webpack_public_path__ + "img/116023.1d8fef50.png";